import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instanceovl8he3jiijf as Companion_instance } from './AbstractList.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { removeAll3o43e67jmwdpc as removeAll } from './MutableCollections.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.o6_1 = $outer;
        this.m6_1 = 0;
        this.n6_1 = -1;
      }
      n1() {
        return this.m6_1 < this.o6_1.p1();
      }
      o1() {
        if (!this.n1())
          throw NoSuchElementException().y1();
        var tmp = this;
        var _unary__edvuaz = this.m6_1;
        this.m6_1 = _unary__edvuaz + 1 | 0;
        tmp.n6_1 = _unary__edvuaz;
        return this.o6_1.q1(this.n6_1);
      }
      l6() {
        // Inline function 'kotlin.check' call
        if (!!(this.n6_1 === -1)) {
          var message = 'Call next() or previous() before removing element from the iterator.';
          throw IllegalStateException().o4(toString(message));
        }
        this.o6_1.z3(this.n6_1);
        this.m6_1 = this.n6_1;
        this.n6_1 = -1;
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.t6_1 = $outer;
        super($outer, $box);
        Companion_instance.u6(index, this.t6_1.p1());
        this.m6_1 = index;
      }
      v6() {
        return this.m6_1 > 0;
      }
      w6() {
        return this.m6_1;
      }
      x6() {
        if (!this.v6())
          throw NoSuchElementException().y1();
        var tmp = this;
        this.m6_1 = this.m6_1 - 1 | 0;
        tmp.n6_1 = this.m6_1;
        return this.t6_1.q1(this.n6_1);
      }
      y6() {
        return this.m6_1 - 1 | 0;
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractMutableList() {
      static d7(list, fromIndex, toIndex) {
        var $this = this.e7();
        $this.a7_1 = list;
        $this.b7_1 = fromIndex;
        $this.c7_1 = 0;
        Companion_instance.r5($this.b7_1, toIndex, $this.a7_1.p1());
        $this.c7_1 = toIndex - $this.b7_1 | 0;
        return $this;
      }
      y3(index, element) {
        Companion_instance.u6(index, this.c7_1);
        this.a7_1.y3(this.b7_1 + index | 0, element);
        this.c7_1 = this.c7_1 + 1 | 0;
      }
      q1(index) {
        Companion_instance.f7(index, this.c7_1);
        return this.a7_1.q1(this.b7_1 + index | 0);
      }
      z3(index) {
        Companion_instance.f7(index, this.c7_1);
        var result = this.a7_1.z3(this.b7_1 + index | 0);
        this.c7_1 = this.c7_1 - 1 | 0;
        return result;
      }
      b2(index, element) {
        Companion_instance.f7(index, this.c7_1);
        return this.a7_1.b2(this.b7_1 + index | 0, element);
      }
      g7(fromIndex, toIndex) {
        this.a7_1.g7(this.b7_1 + fromIndex | 0, this.b7_1 + toIndex | 0);
        this.c7_1 = this.c7_1 - (toIndex - fromIndex | 0) | 0;
      }
      p1() {
        return this.c7_1;
      }
      k6() {
        return this.a7_1.k6();
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [AbstractMutableList(), RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var AbstractMutableListClass;
function AbstractMutableList() {
  if (AbstractMutableListClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static e7() {
        var $this = this.i6();
        $this.p6_1 = 0;
        return $this;
      }
      v(element) {
        this.k6();
        this.y3(this.p1(), element);
        return true;
      }
      v3() {
        this.k6();
        this.g7(0, this.p1());
      }
      w2(elements) {
        this.k6();
        return removeAll(this, (it) => elements.t1(it));
      }
      x3(elements) {
        this.k6();
        return removeAll(this, (it) => !elements.t1(it));
      }
      m1() {
        return new (IteratorImpl())(this);
      }
      t1(element) {
        return this.s1(element) >= 0;
      }
      s1(element) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            if (equals(item, element)) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        return tmp$ret$1;
      }
      u1(index) {
        return new (ListIteratorImpl())(this, index);
      }
      m3(fromIndex, toIndex) {
        return SubList().d7(this, fromIndex, toIndex);
      }
      g7(fromIndex, toIndex) {
        var iterator = this.u1(fromIndex);
        // Inline function 'kotlin.repeat' call
        var times = toIndex - fromIndex | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            iterator.o1();
            iterator.l6();
          }
           while (inductionVariable < times);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.h7(this, other);
      }
      hashCode() {
        return Companion_instance.i7(this);
      }
    }
    initMetadataForClass($, 'AbstractMutableList', VOID, VOID, [AbstractMutableCollection(), KtMutableList()]);
    AbstractMutableListClass = $;
  }
  return AbstractMutableListClass;
}
//region block: exports
export {
  AbstractMutableList as AbstractMutableList192xfq8ycgofs,
};
//endregion

//# sourceMappingURL=AbstractMutableListJs.mjs.map
